(() => {
  const marker = '__chicUpfrontPreorderCompatibility';
  function approvedPlans() {
    const plans = new Set();
    document.querySelectorAll('script[data-chic-upfront-preorder-plans]').forEach(script => {
      try {
        const ids = JSON.parse(script.textContent || '[]');
        if (Array.isArray(ids)) ids.forEach(id => {
          if (typeof id === 'string' && /^\d+$/.test(id)) plans.add(id);
        });
      } catch (_) {}
    });
    return plans;
  }
  function normalizeBody(body, isCartChange) {
    const plans = approvedPlans();
    if (!plans.size || !body) return body;
    if (body instanceof FormData || body instanceof URLSearchParams) {
      for (const key of [...body.keys()]) {
        if (key !== 'selling_plan' && !/^items\[\d+\]\[selling_plan\]$/.test(key)) continue;
        if (!plans.has(String(body.get(key)))) continue;
        if (isCartChange) body.set(key, '');
        else body.delete(key);
      }
      return body;
    }
    if (typeof body === 'object') {
      const lines = Array.isArray(body.items) ? body.items : [body];
      lines.forEach(line => {
        if (!line || !plans.has(String(line.selling_plan))) return;
        if (isCartChange) line.selling_plan = null;
        else delete line.selling_plan;
      });
    }
    return body;
  }
  function install() {
    const app = window._RestockRocket;
    const original = app?.addSellingPlanToCartParams;
    if (typeof original !== 'function') return false;
    if (!original[marker]) {
      const wrapped = async function (...args) {
        const body = await original.apply(this, args);
        return normalizeBody(body, args[3] === true);
      };
      wrapped[marker] = true;
      app.addSellingPlanToCartParams = wrapped;
    }
    document.documentElement.setAttribute('data-chic-upfront-preorder-compatibility', 'active');
    return true;
  }
  if (!install()) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts++;
      if (install() || attempts >= 60) clearInterval(timer);
    }, 250);
  }
  document.addEventListener('DOMContentLoaded', install, { once: true });
  window.addEventListener('load', install, { once: true });
  document.addEventListener('load', event => {
    if (event.target?.tagName === 'SCRIPT') setTimeout(install, 0);
  }, true);
})();

